import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Polices auto-hébergées. Jamais de Google Fonts en CDN : le chargement
// transmettrait l'adresse IP de chaque participant à un tiers hors UE, ce qui
// contredirait le premier argument de vente du produit (section 6).
// DA « projection privée » : Inter (300/400/500) + Cormorant Garamond italique
// pour le mot d'accent des titres.
import '@fontsource-variable/inter';
import '@fontsource/cormorant-garamond/500-italic.css';

import '@eventmatch/design-tokens/tokens.css';
import './styles/lovable.css';
import './styles/base.css';
import './app.css';

import { App } from './App.tsx';
import { FournisseurLibelles } from './i18n.tsx';
import { FournisseurSession } from './etat.tsx';

// Détection de langue : choix mémorisé > langue du navigateur > français.
// La même détection vaut pour la vitrine publique, l'app participant et l'admin.
const LANGUES = ['fr', 'nl', 'en'] as const;
function detecterLangue(): string {
  try {
    const memorisee = localStorage.getItem('eventmatch.langue');
    if (memorisee && (LANGUES as readonly string[]).includes(memorisee)) return memorisee;
  } catch {
    /* stockage indisponible */
  }
  const navigateur = navigator.language?.slice(0, 2).toLowerCase();
  return (LANGUES as readonly string[]).includes(navigateur) ? navigateur : 'fr';
}

createRoot(document.getElementById('racine')!).render(
  <StrictMode>
    <BrowserRouter>
      <FournisseurLibelles langue={detecterLangue()}>
        <FournisseurSession>
          <App />
        </FournisseurSession>
      </FournisseurLibelles>
    </BrowserRouter>
  </StrictMode>,
);

// Le service worker n'est enregistré qu'en production : en développement il
// masquerait les modifications derrière son cache.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((erreur) => {
      console.warn('service worker non enregistré', erreur);
    });
  });
}
